import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Today from '@mui/icons-material/Today';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { primary } from '../../../../../../utils/brandColors';
import theme from '../../../../../../utils/theme';

const RBCToolbar = ({
  label,
  date,
  view,
  views,
  onView,
  onNavigate,
}) => {
  const fullscreen = useMediaQuery(theme.breakpoints.down('md'));
  const phone = useMediaQuery(theme.breakpoints.down('sm'));
  const [month, setMonth] = React.useState('January');
  const mMonth = moment(date).format('MMMM');
  const months = moment.months();

  React.useEffect(() => {
    setMonth(mMonth);
  }, [mMonth]);

  const onChange = (event) => {
    const current = event.target.value;
    onNavigate('DATE', moment().month(current).toDate());
    setMonth(current);
  };

  const goToView = (v) => {
    onView(v);
  };

  const goToBack = () => {
    onNavigate('PREV');
  };
  const goToNext = () => {
    onNavigate('NEXT');
  };

  const goToToday = () => {
    onNavigate('TODAY');
  };

  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ mb: 1 }}>
      <Grid
        sx={[{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
        }]}
        size={{
          xs: 5,
          sm: 4,
          md: 4,
          lg: 5,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<Today />}
          size="small"
          onClick={goToToday}
        >Today
        </Button>
        {/* <IconButton
          onClick={goToToday}
        > <Today />
        </IconButton> */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Tooltip title="Previous">
            <IconButton
              onClick={goToBack}
              size="small"
              sx={{ backgroundColor: primary.main }}
            ><ChevronLeft sx={{ color: '#ffffff' }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Next"><IconButton size="small" variant="contained" sx={{ backgroundColor: primary.main }} onClick={goToNext}><ChevronRight sx={{ color: '#ffffff' }} /></IconButton></Tooltip>
        </Box>
      </Grid>
      {
        !phone
          ? (
            <Grid
              size={{
                xs: 12,
                sm: 4,
                md: 4,
                lg: 2,
              }}
            >
              <Typography variant="subtitle1" color="primary" align="center">
                {view === 'month'
                  ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FormControl
                        sx={{
                          m: 0,
                          width: 130,
                        }}
                        size="small"
                      >
                        <Select
                          labelId="cal-select-month"
                          id="cal-select-month"
                          value={month}
                          onChange={onChange}
                        >
                          {months?.map((m) => (
                            <MenuItem value={m} key={m}>{m}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Typography
                        sx={{
                          ml: 1,
                          fontSize: 20,
                        }}
                      >{moment(date).format('YYYY')}
                      </Typography>
                    </Box>
                  )
                  : (
                    label
                  )}
              </Typography>
            </Grid>
          )
          : (
            <Grid size={2} />
          )
      }
      <Grid
        align="right"
        size={{
          xs: 5,
          sm: 4,
          md: 4,
          lg: 5,
        }}
      >
        <ToggleButtonGroup
          color="primary"
          value={view}
          exclusive
          onChange={(e, newView) => {
            goToView(newView)
          }}
          aria-label="Calendar View"
        >
          {views?.map((item) => (
            <ToggleButton
              size="small"
              value={item}
              key={item}
              sx={[fullscreen
                ? { px: 1 }
                : { px: null }]}
            >{fullscreen
              ? item.charAt(0)
              : item}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
      {
        phone && (
          <Grid justifyContent="center" sx={{ display: 'flex' }} size={12}>
            {view === 'month'
              ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FormControl
                    sx={{
                      m: 0,
                      width: 130,
                    }}
                    size="small"
                  >
                    <Select
                      labelId="cal-select-month"
                      id="cal-select-month"
                      value={month}
                      onChange={onChange}
                    >
                      {months?.map((m) => (
                        <MenuItem value={m} key={m}>{m}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Typography
                    sx={{
                      ml: 1,
                      fontSize: 20,
                    }}
                  >{moment(date).format('YYYY')}
                  </Typography>
                </Box>
              )
              : (
                label
              )}
          </Grid>
        )
      }
    </Grid>
  );
}

export default RBCToolbar;

RBCToolbar.propTypes = {
  label: PropTypes.any.isRequired,
  date: PropTypes.any.isRequired,
  view: PropTypes.any.isRequired,
  views: PropTypes.any.isRequired,
  onView: PropTypes.any.isRequired,
  onNavigate: PropTypes.any.isRequired,
}
